import { useEffect, useState } from "react";
import Layout from "../../Layout";
import { Col, DatePicker, Form, Input, message, Row, Select } from "antd";
import ProcedureService from "../../Services/ProcedureService";
import moment from "moment";
import CommonService from "../../Services/CommonService";
import { useDispatch, useSelector } from "react-redux";
import {
  handleLoginSignUpModal,
  LOGINMODAL,
} from "../../Redux/actions/commonActions";
import image1 from "../../assets/images/procedureicons/procedure5year.svg";
import image2 from "../../assets/images/procedureicons/procedure2.svg";
import image3 from "../../assets/images/procedureicons/procedure3.svg";
import image4 from "../../assets/images/procedureicons/procedure4.svg";
import phone from "../../assets/images/procedureicons/phoneicon.svg";
import banner from "../../assets/images/procedure.png";
import dayjs from "dayjs";
const { Option } = Select;

function HospitalService() {
  const [form] = Form.useForm();
  const { loggedUser, patientData: reduxPatientData } = useSelector(
    (state) => state.auth,
  );
  const getStoredPatient = () => {
    try {
      const storedPatient = localStorage.getItem("patientData");
      return storedPatient ? JSON.parse(storedPatient) : null;
    } catch (error) {
      console.error("Error reading patient data:", error);
      return null;
    }
  };
  const [activePatient, setActivePatient] = useState(
    loggedUser || reduxPatientData || getStoredPatient(),
  );
  const patientCode = activePatient?.patientId;
  const patientName = `${activePatient?.salutation || ""}${
    activePatient?.firstName || ""
  } ${activePatient?.lastName || ""}`.trim();
  const [countries, setCountries] = useState([]);
  const [hospitalData, setHospitalData] = useState([]);
  const [hospitalValue, setHospitalValue] = useState(null);
  const dispatch = useDispatch();
  const initialValues = {
    patientName: "",
    mobile: "",
    email: "",
    passportNumber: "",
    plannedService: "",
    city: "",
    country: "",
    plannedDate: "",
    preferredHospital: "",
  };
  const [formData, setFormData] = useState(initialValues);

  useEffect(() => {
    if (activePatient?.patientId) {
      fetchHospitalList();
      getCountriesList();
    }
  }, [activePatient?.patientId]);

  useEffect(() => {
    const currentPatient = loggedUser || reduxPatientData || getStoredPatient();
    setActivePatient(currentPatient);

    if (currentPatient?.patientId) {
      const currentPatientName = `${currentPatient?.salutation || ""}${
        currentPatient?.firstName || ""
      } ${currentPatient?.lastName || ""}`.trim();

      setFormData((prev) => ({
        ...prev,
        patientName: currentPatientName,
        mobile: currentPatient.mobile || "",
        email: currentPatient.email || "",
      }));
    }
  }, [loggedUser, reduxPatientData]);

  const getCountriesList = async () => {
    let payload = {
      status: 1,
    };
    const response = await CommonService.CountriesList(payload);
    setCountries(response.data);
  };
  const COUNTRYCODE = process.env.REACT_APP_COUNTRYCODE || "";
  const fetchHospitalList = () => {
    let payload = {
      status: 1,
      accountRoleType: "clinic",
      pageNo: "1",
      pageSize: "10",
    };
    if (COUNTRYCODE) {
      payload.country_Id = COUNTRYCODE;
    }
    ProcedureService.HosiptalList(payload)
      .then((result) => {
        setHospitalData(result.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleHospitalChange = (selectedItem) => {
    setFormData((prev) => ({
      ...prev,
      preferredHospital: selectedItem?.account_Name,
    }));
    setHospitalValue(selectedItem || "");
  };

  const convertUTCDate = (date, format) => {
    if (!format) {
      const d = new Date();
      date = new Date(
        moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
          " " +
          d.getHours() +
          ":" +
          d.getMinutes(),
      );
    }
    format = format || "MM/DD/YYYY";
    return moment(new Date(date)).utc().format(format);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let values = formData;
    const mandatoryFields = [
      "patientName",
      "mobile",
      "email",
      "plannedService",
      "city",
      "country",
      "plannedDate",
      "preferredHospital",
    ];

    const emptyFields = mandatoryFields.filter((field) => !values[field]);

    if (!activePatient?.patientId) {
      dispatch(handleLoginSignUpModal({ data: true, actionType: LOGINMODAL }));
      return;
    }

    if (emptyFields.length > 0) {
      message.error("Please fill in all mandatory fields");
      return;
    }
    const countryCode = countries.find(
      (country) => country.country_Name === values.country,
    )?.country_Id;
    let payload = {
      account_Id: hospitalValue?.account_Id,
      city: values.city,
      clinic_Id: hospitalValue?.clinic_Id,
      country: countryCode,
      createdBy: patientCode,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      email: values.email,
      mobile: values.mobile,
      modifiedBy: patientCode,
      passportNumber: values.passportNumber,
      patientId: patientCode,
      patientName: patientName,
      pincode: values.pincode,
      plannedDate: dayjs(values.plannedDate).format("MM/DD/YYYY"),
      plannedService: values.plannedService,
      preferredHospital: hospitalValue?.clinic_Name,
      status: 1,
      state: "",
    };

    ProcedureService.ProcedureRequest(payload)
      .then((result) => {
        form.resetFields();
        setHospitalValue(null);
        setFormData(initialValues);
        message.success("Procedure Quote added successfully");
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (name, value) => {
    if (name === "country") {
      const selected = countries.find((c) => c.country_Id === value);
      setFormData((prev) => ({
        ...prev,
        country: selected?.country_Name || "",
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleDateChange = (date) => {
    setFormData((prev) => ({
      ...prev,
      plannedDate: date,
    }));
  };
  return (
    <Layout>
      <div className=" h-screen my-2">
        <div className="w-[70%] sm:w-[80%] m-auto ">
          <div className="flex sm:flex-col mt-10 border border-[#CDE0E2] rounded-md bg-[#DFF8F1] sm:h-full h-[400px]">
            <div className="w-[55%] sm:w-full font-semibold flex flex-col gap-2 text-2xl sm:text-xl p-4 font-inter">
              <span>Trusted Surgical Experts Near You</span>
              <span className="text-[#189FAA]">
                Advanced care, made simple.
              </span>
              <span className="font-medium text-sm mt-2">
                Continuum of care for pre & post surgical procedure.
              </span>

              <span className="w-40 text-center font-medium text-sm mt-4 border p-1 rounded-md bg-[#F2FFFB]">
                Holistic Treatment
              </span>

              <div className="grid grid-cols-2 sm:grid-cols-1 text-sm font-normal gap-4">
                <div className="flex gap-2 items-center">
                  <img src={image1} alt="img" className="mt-1" />
                  <span>
                    5+ Years of Trusted <br />
                    Surgical Experience
                  </span>
                </div>
                <div className="flex gap-2 items-center">
                  <img src={image2} alt="img" className="mt-1" />
                  <span>
                    24/7 Access to <br />
                    Medical Experts
                  </span>
                </div>
                <div className="flex gap-2 items-center">
                  <img src={image3} alt="img" className="mt-1" />
                  <span>
                    Personalized Treatment <br />
                    Plans for Every Patient
                  </span>
                </div>
                <div className="flex gap-2 items-center">
                  <img src={image4} alt="img" className="mt-1" />
                  <span>
                    Certified Surgeons <br />
                    Across Leading Hospitals
                  </span>
                </div>
              </div>

              <div className="text-sm font-medium my-4 flex sm:flex-col gap-6 items-center">
                <div>Contact us for healthcare services</div>
                <div className="border bg-[#FFFFFF] p-1 rounded-md flex gap-2 items-center">
                  <img src={phone} alt="img" />
                  <span>+254 712 XXX 678</span>
                </div>
              </div>
            </div>

            <div
              className="w-[45%] h-full bg-no-repeat bg-cover bg-center rounded-r-md"
              style={{ backgroundImage: `url(${banner})` }}
            ></div>
          </div>

          <div className="md:flex flex-col  justify-center items-center my-4">
            <div className="shadow-lg border rounded-lg bg-white p-5">
              <form onSubmit={handleSubmit} autoComplete="off" className="p-4">
                <h2 className="text-2xl sm:text-xl text-center text-teal-600 font-bold mb-1">
                  Procedure Quote
                </h2>
                <p className="text-center mb-6 text-gray-600">
                  Get a quick estimate for your planned treatment by sharing a
                  few basic details.
                </p>

                <Row gutter={[16, 24]}>
                  <Col xs={24} sm={12} md={8}>
                    <div className="relative w-full">
                      <span className="absolute -top-2 text-xs font-semibold z-10 left-3 bg-white px-1">
                        Patient Name <span style={{ color: "#FF000F" }}>*</span>
                      </span>
                      <input
                        type="text"
                        name="patientName"
                        id="patientName"
                        className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] focus:border-[#189FAA] bg-[#F2FFFB]"
                        value={formData.patientName}
                        onChange={handleChange}
                      />
                    </div>
                  </Col>

                  <Col xs={24} sm={12} md={8}>
                    <div className="relative w-full">
                      <span className="absolute -top-2 text-xs font-semibold z-10 left-3 bg-white px-1">
                        Mobile Number{" "}
                        <span style={{ color: "#FF000F" }}>*</span>
                      </span>
                      <input
                        type="text"
                        name="mobile"
                        id="mobile"
                        className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] focus:border-[#189FAA] bg-[#F2FFFB]"
                        value={formData.mobile}
                        onChange={handleChange}
                      />
                    </div>
                  </Col>

                  <Col xs={24} sm={12} md={8}>
                    <div className="relative w-full">
                      <span className="absolute -top-2 text-xs font-semibold z-10 left-3 bg-white px-1">
                        Email Id <span style={{ color: "#FF000F" }}>*</span>
                      </span>
                      <input
                        type="text"
                        name="email"
                        id="email"
                        className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] focus:border-[#189FAA] bg-[#F2FFFB]"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                  </Col>

                  <Col xs={24} sm={12} md={8}>
                    <div className="relative w-full">
                      <span className="absolute -top-2 text-xs font-semibold z-10 left-3 bg-white px-1">
                        Passport Number
                      </span>
                      <input
                        type="text"
                        name="passportNumber"
                        id="passportNumber"
                        className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] focus:border-[#189FAA] bg-[#F2FFFB]"
                        value={formData.passportNumber}
                        onChange={handleChange}
                        disabled={COUNTRYCODE === "KE" ? false : true}
                      />
                    </div>
                  </Col>

                  <Col xs={24} sm={12} md={8}>
                    <div className="relative w-full">
                      <span className="absolute -top-2 text-xs font-semibold z-10 left-3 bg-white px-1">
                        Planned Service{" "}
                        <span style={{ color: "#FF000F" }}>*</span>
                      </span>
                      <input
                        type="text"
                        name="plannedService"
                        id="plannedService"
                        className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] focus:border-[#189FAA] bg-[#F2FFFB]"
                        value={formData.plannedService}
                        onChange={handleChange}
                      />
                    </div>
                  </Col>

                  <Col xs={24} sm={12} md={8}>
                    <div className="relative w-full">
                      <span className="absolute -top-2 text-xs font-semibold z-10 left-3 bg-white px-1">
                        City <span style={{ color: "#FF000F" }}>*</span>
                      </span>
                      <input
                        type="text"
                        name="city"
                        id="city"
                        className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] focus:border-[#189FAA] bg-[#F2FFFB]"
                        value={formData.city}
                        onChange={handleChange}
                      />
                    </div>
                  </Col>

                  <Col xs={24} sm={12} md={8}>
                    <div className="relative w-full">
                      <span className="absolute -top-2 text-xs font-semibold z-10 left-3 bg-white px-1">
                        Country <span style={{ color: "#FF000F" }}>*</span>
                      </span>

                      <Select
                        allowClear
                        value={
                          countries.find(
                            (c) => c.country_Name === formData.country,
                          )?.country_Id
                        }
                        onChange={(value) =>
                          handleSelectChange("country", value)
                        }
                        className="h-10 w-full consult-select-bg border rounded-md text-sm"
                        dropdownStyle={{ backgroundColor: "#F2FFFB" }}
                      >
                        {countries?.map((country) => (
                          <Option
                            key={country.country_Id}
                            value={country.country_Id}
                            label={country.country_Name}
                          >
                            {country.country_Name}
                          </Option>
                        ))}
                      </Select>
                    </div>
                  </Col>

                  <Col xs={24} sm={12} md={8}>
                    <div className="relative w-full">
                      <span className="absolute -top-2 text-xs font-semibold z-10 left-3 bg-white px-1">
                        Planned Date <span style={{ color: "#FF000F" }}>*</span>
                      </span>

                      <DatePicker
                        format="MM/DD/YYYY"
                        value={formData.plannedDate}
                        onChange={handleDateChange}
                        className="h-10 w-full border border-gray-300 rounded-md bg-[#F2FFFB] text-sm"
                      />
                    </div>
                  </Col>

                  <Col xs={24} sm={12} md={8}>
                    <div className="relative w-full">
                      <span className="absolute -top-2 font-semibold text-xs z-10 left-3 bg-white px-1">
                        Preferred Hospital{" "}
                        <span style={{ color: "#FF000F" }}>*</span>
                      </span>

                      <Select
                        allowClear
                        showSearch
                        value={
                          formData.preferredHospital
                            ? hospitalData.find(
                                (item) =>
                                  item.clinic_Id === formData.preferredHospital,
                              )?.clinic_Id
                            : undefined
                        }
                        onChange={(value) => {
                          const selectedItem = hospitalData.find(
                            (item) => item.clinic_Id === value,
                          );
                          handleHospitalChange(selectedItem);
                        }}
                        filterOption={(input, option) =>
                          option?.label
                            ?.toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        className="h-10 w-full custom-select-bg border border-gray-300 rounded-md bg-[#F2FFFB] text-sm"
                        dropdownStyle={{ backgroundColor: "#F2FFFB" }}
                      >
                        {hospitalData.map((item) => (
                          <Option
                            key={item.clinic_Id}
                            value={item.clinic_Id}
                            label={item.clinic_Name}
                          >
                            {item.clinic_Name}
                          </Option>
                        ))}
                      </Select>
                    </div>
                  </Col>

                  <Col xs={24} className="text-center">
                    <button
                      type="submit"
                      className="mt-4 bg-teal-500 w-full w-60 rounded-lg border text-white font-semibold px-6 py-2"
                    >
                      Submit the Quote
                    </button>
                  </Col>
                </Row>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default HospitalService;
